import { articles } from "./newsData";
import "./NewsDetail.css";

const formatFullDate = (dateStr) => {
  const date = new Date(dateStr);
  if (!dateStr || isNaN(date.getTime())) return "";
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

function NewsDetail({ articleId, onBack }) {
  const article = articles.find((a) => a.id === articleId);
  if (!article) return null;

  return (
    <div className="news-detail">
      <button className="news-detail-back" onClick={onBack}>
        ← Retour
      </button>
      <span className="news-detail-category">{article.category}</span>
      <h1 className="news-detail-title">{article.title}</h1>
      <p className="news-detail-date">{formatFullDate(article.pubDate)}</p>
      <div className="news-detail-divider" />
      <div className="news-detail-body">
        {article.body.trim().split("\n\n").map((para, i) => (
          <p key={i}>{para}</p>
        ))}
      </div>
    </div>
  );
}

export default NewsDetail;
